import React from 'react';
import { Text } from '@tamagui/core';
import { YStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import { FONT_SIZE_SECTION, ITEM_GAP } from '../constants';

type AboutSectionProps = {
  about: string;
  isDark?: boolean;
};

const AboutSection = React.memo<AboutSectionProps>(({ about, isDark }) => {
  const textColor = isDark ? COLORS.WHITE : COLORS.BLACK;
  
  return (
    <YStack gap={ITEM_GAP}>
      <Text fontSize={FONT_SIZE_SECTION} fontWeight="700" color={textColor}>
        O Mnie
      </Text>
      <Text color={textColor}>{about}</Text>
    </YStack>
  );
});

AboutSection.displayName = 'AboutSection';

export default AboutSection;

